import { createAction } from 'redux-actions';
import { GlobalInboxFilterRequestType } from '@ts/inbox.types';

export const setSelectedInboxStatus = createAction<number[]>('SET_SELECTED_INBOX_STATUS');
export const setSelectedMailboxesIds = createAction<number[]>('SET_SELECTED_MAILBOXES_IDS');
export const setInboxFilters = createAction<GlobalInboxFilterRequestType>('SET_FILTER');
